import React from 'react';

import type { DepositsItem } from 'types/api/deposits';

import config from 'configs/app';
import useLazyRenderedList from 'lib/hooks/useLazyRenderedList';
import { TableBody, TableColumnHeader, TableHeaderSticky, TableRoot, TableRow } from 'toolkit/chakra/table';
import TimeFormatToggle from 'ui/shared/time/TimeFormatToggle';

import BeaconChainDepositsTableItem from './BeaconChainDepositsTableItem';

const feature = config.features.beaconChain;

type Props = {
  top: number;
  isLoading?: boolean;
  items: Array<DepositsItem>;
  view: 'list' | 'address' | 'block';
};

const BeaconChainDepositsTable = ({ items, isLoading, top, view }: Props) => {
  const { cutRef, renderedItemsNum } = useLazyRenderedList(items, !isLoading);

  if (!feature.isEnabled) {
    return null;
  }

  return (
    <TableRoot style={{ tableLayout: 'auto' }} minW="950px">
      <TableHeaderSticky top={ top }>
        <TableRow>
          <TableColumnHeader>交易哈希</TableColumnHeader>
          { view !== 'block' && <TableColumnHeader>区块</TableColumnHeader> }
          { view !== 'block' && <TableColumnHeader>时间戳<TimeFormatToggle/></TableColumnHeader> }
          <TableColumnHeader>{ `Value ${ feature.currency.symbol }` }</TableColumnHeader>
          { view !== 'address' && <TableColumnHeader>发送方</TableColumnHeader> }
          <TableColumnHeader>PubKey</TableColumnHeader>
          <TableColumnHeader>Signature</TableColumnHeader>
          <TableColumnHeader>状态</TableColumnHeader>
        </TableRow>
      </TableHeaderSticky>
      <TableBody>
        { items.slice(0, renderedItemsNum).map((item, index) => (
          <BeaconChainDepositsTableItem key={ item.index + (isLoading ? String(index) : '') } item={ item } view={ view } isLoading={ isLoading }/>
        )) }
        <TableRow ref={ cutRef }/>
      </TableBody>
    </TableRoot>
  );
};

export default BeaconChainDepositsTable;
